import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
} from '@angular/core';
import { LoaderComponent } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  constructor(
    private resolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {}

  loaderCounter = 0;

  off(count?: boolean) {
    let containerLoader = document.getElementById('containerLoader');
    if (count && containerLoader) {
      this.loaderCounter = this.loaderCounter - 1;
    }
    if (containerLoader && (count ? this.loaderCounter == 0 : true)) {
      containerLoader.remove();
    }
  }

  on(img?: any, imgClass?: string, customClass?: string) {
    let containerLoader = document.getElementById('containerLoader');
    if (!containerLoader) {
      containerLoader = document.createElement('div');
      containerLoader.id = 'containerLoader';
      document.body.appendChild(containerLoader);

      const loader = this.resolver.resolveComponentFactory(LoaderComponent);

      const componentRef = loader.create(this.injector);
      if (img) {
        componentRef.instance.img = img;
      }
      if (imgClass) {
        componentRef.instance.imgClass = imgClass;
      }
      if (customClass) {
        componentRef.instance.customClass = customClass;
      }
      this.applicationRef.attachView(componentRef.hostView);
      containerLoader.appendChild(componentRef.location.nativeElement);

      this.loaderCounter = 1;
    } else {
      this.loaderCounter = this.loaderCounter + 1;
    }
  }
}
